"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var htmlHelper_1 = require("./htmlHelper");
exports.default = new /** @class */ (function () {
    function IconHelper() {
    }
    IconHelper.prototype.generateAllDocumentIcons = function (rootNode) {
        if (rootNode === void 0) { rootNode = document; }
        this.generateDocumentIconsForExtension(rootNode, 'pdf', 'file-pdf');
        this.generateDocumentIconsForExtension(rootNode, 'txt', 'file-document');
        this.generateDocumentIconsForExtension(rootNode, 'docx', 'file-word');
        this.generateDocumentIconsForExtension(rootNode, 'xlsx', 'file-excel');
    };
    IconHelper.prototype.generateDocumentIconsForExtension = function (rootNode, extension, icon) {
        var documentLinks = rootNode.querySelectorAll('a[href*=".' + extension + '"]');
        documentLinks.forEach(function (documentLink) {
            var iconElement = documentLink.querySelector('.mdi, .material-icons, .o-icon');
            if (!iconElement) {
                iconElement = htmlHelper_1.default.createElementFromHTML('<span class="pr-1 mdi mdi-' + icon + '"></span>');
                documentLink.prepend(iconElement);
            }
        });
    };
    return IconHelper;
}());
